
const ProdEnv = window.Env;

const DevEnv = {
  apiEndpoint: "http://127.0.0.1:5000/",
  stripeApiKey: "pk_test_51Hi2ErKPztz4xlCqMnQRvvwzYdWcdMVAcNVrh3xYbsvK4DLj4b45YQdnz97W9fmuC8NlFdtnNowbinVHDYZsqfQF00URRqh45D",
};

const Env = process.env.NODE_ENV === 'development' ? DevEnv : ProdEnv;

export const { apiEndpoint, stripeApiKey } = Env;
